export const DINING = {
    id: "5-dining",
    name: "Dining Room",
    returnToView: [
        {
            text: "Reset View",
            target: "0-init",
        },
    ],
    levels: [
        {
            tileSize: 256,
            size: 256,
            fallbackOnly: true,
        },
        {
            tileSize: 512,
            size: 512,
        },
        {
            tileSize: 512,
            size: 1024,
        },
        {
            tileSize: 512,
            size: 2048,
        },
    ],
    faceSize: 2048,
    initialViewParameters: {
        yaw: -0.26313751586415535,
        pitch: 0.5365232170272254,
        fov: 1.403086486818207,
    },
    linkHotspots: [
        {
            yaw: -2.9327770721486317,
            pitch: 0.24663374855382436,
            rotation: 6.283185307179586,
            target: "2-island",
        },
        {
            yaw: 2.4416047090065147,
            pitch: 0.44614432548021377,
            rotation: 4.71238898038469,
            target: "4-prep",
        },
        {
            yaw: 2.652385845067119,
            pitch: 0.10021156996898384,
            rotation: 19.63495408493622,
            target: "3-nook",
        },
        {
            yaw: -2.3364271016914735,
            pitch: 0.22597264254607197,
            rotation: 5.497787143782138,
            target: "0-init",
        },
        {
            yaw: 3.074403488303995,
            pitch: -0.028523076121407698,
            rotation: 9.42477796076938,
            target: "1-range",
        },
    ],
    infoHotspots: [
        {
            singlePaneModal: true,
            video: true,
            yaw: -1.0573079189428185,
            pitch: 0.9157499891316814,
            class: "hidden-icon",
            title: `Golden Spoon #3`,
            text: `<div style="position:relative;width:100%;height:0;padding-bottom:56.25%;"><iframe src="https://pamperedchef.widen.net/view/video/afadjjqto7/video-table-ss22-final-spoon-code-virtual-kitchen-usca.mp4?u=intbhg" webkitallowfullscreen mozallowfullscreen allowfullscreen frameborder="0" allowtransparency="true" scrolling="no" style="position:absolute;top:0;left:0;width:100%;height:100%;" ></iframe></div>`,
        },
        {
            yaw: -0.09869637391128983,
            pitch: 0.3819358258744394,
            title: `Create Everyday Wins`,
            pdf: true,
            text: `<iframe src="https://pamperedchef.widen.net/view/pdf/hzjkbs6atu/flyer-table-nck-spring-2021-usca.pdf?t.download=true" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>`,
        },
        {
            yaw: 0.599792886765794,
            pitch: 0.589035593330788,
            title: `Host A Party. Get Rewards.`,
            pdf: true,
            text: `<iframe src="https://pamperedchef.widen.net/view/pdf/codo8ffwtl/flyer-table-host-spring-2021-usca.pdf?t.download=true" webkitallowfullscreen mozallowfullscreen allowfullscreen ></iframe>`
        },
        {
            yaw: -0.8584552050575134,
            pitch: 0.14583162492609247,
            title: `Season’s Best®`,
            subhead: "Season’s Best® (Spring/Summer 2021)",
            text: `
    <ul>
      <li><b>#100765</b></li>
      <li>
        <b>USD</b>
        $2 |
        <b>CAD</b>
        $3
      </li>
      <li>
        Twice each year we create a Season's Best collection that showcases some
        of our favorite in-season flavors.
      </li>
      <li>
        You can turn everyday recipes into something exciting and new by making
        just one small change—a new seasoning, a new ingredient, or cooking in a
        new way. Whether you air fry, pressure cook, or give sous vide a try,
        our foolproof recipes will give you delicious results!
      </li>

      <span class="title pad-up">Sides &amp; Apps</span>
      <li>Polenta Fries With Creamy Pesto</li>
      <li>Pressure Cooker Beet Salad</li>
      <li>Fried Pickle Dip</li>
      <li>Loaded Potato Wedges</li>

      <span class="title">Mains</span>
      <li>Sous Vide Stuffed Burgers</li>
      <li>Chicken Naan Wraps With Peri-Peri Sauce</li>
      <li>Eggplant Meatballs</li>
      <li>Sous Vide Pork Tenderloin With Vegetables</li>
      <li>Grilled Honey Garlic Chicken</li>
      <li>Pressure Cooker Barbacoa Burrito Bowl With Cilantro-Lime Rice</li>
      <li>Cacio e Pepe With Zucchini &amp; Peas</li>
      <li>Baja Cod Air Fryer Tostadas</li>
      <li>Tomato Basil Tart With Whipped Mozzarella</li>

      <span class="title">Desserts</span>
      <li>Peach Bread Pudding</li>
      <li>
        Lemon-Raspberry Cheesecake With Raspberry Whipped Cream
      </li>
      <li>
        Also in the <b>Season's Best® Pantry Bundle:</b> Garlic &amp; Herb Rub,
        Chipotle Rub, Chili Lime Rub, Herbs De Provence Seasoning Mix, and
        Season's Best®.
      </li>
    </ul>
  `,
            images: [
                `<img width="640" alt="seasons-best-01.jpeg" src="https://pamperedchef.widen.net/content/te8mcabxkv/jpeg/seasons-best-01.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-02.jpeg" src="https://pamperedchef.widen.net/content/rc1ffa5b3u/jpeg/seasons-best-02.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-03.jpeg" src="https://pamperedchef.widen.net/content/8qv264qngo/jpeg/seasons-best-03.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-04.jpeg" src="https://pamperedchef.widen.net/content/zgdm3wqist/jpeg/seasons-best-04.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-05.jpeg" src="https://pamperedchef.widen.net/content/d3du9570aw/jpeg/seasons-best-05.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-06.jpeg" src="https://pamperedchef.widen.net/content/tjkxpchylr/jpeg/seasons-best-06.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
                `<img width="640" alt="seasons-best-07.jpeg" src="https://pamperedchef.widen.net/content/loeroue0rs/jpeg/seasons-best-07.jpeg?w=640&keep=c&crop=yes&color=cccccc&quality=80">`,
            ],
            recipes: [
                {
                    title: `Polenta Fries With Creamy Pesto`,
                    element: `<img class="recipe-preview-img-wrap" width="150" height="150" alt="recipe-post-01.jpeg" src="https://pamperedchef.widen.net/content/mfo1zwglsg/jpeg/recipe-post-01.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/5mkvvlvwlx/recipe-post-01`,
                },
                {
                    title: `Sous Vide Pork Tenderloin With Vegetables`,
                    element: `<img width="150" height="150" class="recipe-preview-img-wrap" alt="recipe-post-04.jpeg" src="https://pamperedchef.widen.net/content/viwo08crop/jpeg/recipe-post-04.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/8vjtzkglpp/recipe-post-04`,
                },
                {
                    title: `Cacio e Pepe With Zucchini & Peas`,
                    element: `<img width="150" height="150" alt="recipe-post-06.jpeg" class="recipe-preview-img-wrap" src="https://pamperedchef.widen.net/content/2qs3fzsloj/jpeg/recipe-post-06.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/fzcrdhnkd9/recipe-post-06`,
                },
                {
                    title: `Baja Cod Air Fryer Tostada`,
                    element: `<img width="150" height="150" alt="recipe-post-07.jpeg" class="recipe-preview-img-wrap" src="https://pamperedchef.widen.net/content/rxg2kyhesr/jpeg/recipe-post-07.jpeg?w=200&h=200&position=c&color=ffffffff&quality=80">`,
                    link: `https://pamperedchef.widen.net/s/5rlnvvdwhk/recipe-post-07`,
                },
            ],
        },
    ],
};
